// i18n helper — admin portal is Danish-only
// t() returns the da strings; prepared for future locale switching

import { da } from './da'
import { en } from './en'

type Locale = 'da' | 'en'

const strings = { da, en } as const

// Admin portal default: Danish
let currentLocale: Locale = 'da'

export function setLocale(locale: Locale) {
  currentLocale = locale
}

export function t() {
  return strings[currentLocale]
}

// Re-export for convenience
export { da, en }
export type { Locale }
